module.exports = __webpack_public_path__ + "img/40.f7d63fc8.svg";